import { render, staticRenderFns } from "./AddressDialog.vue?vue&type=template&id=27046c8f&scoped=true"
import script from "./AddressDialog.vue?vue&type=script&lang=js"
export * from "./AddressDialog.vue?vue&type=script&lang=js"
import style0 from "./AddressDialog.vue?vue&type=style&index=0&id=27046c8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27046c8f",
  null
  
)

export default component.exports